AuthRoute = require 'mixins/authenticated-route'

App.DishGroupsDishGroupRoute = Em.Route.extend AuthRoute,
  afterModel: (model) ->
    @transitionTo 'dish-groups.dish-group.edit', model

  model: (params) ->
    @store.fetchById('dishGroup', params.dish_group_id).then (group) =>
      group.set('relatedDishes', group.get('dish_ids').map (id) =>
          @store.find 'dish', id
      )
